import { createGlobalState } from "react-hooks-global-state";
import { defaultBroadCategories } from "./utils/constants";

const initialState = {
  user: { credits: 0 },
  trips: [],
  userLoading: true,
  showProfile: false,
  openGroupDetails: false,
  openLogin: false,
  openAlertBannerMsg: "",
  sortByHome: "dates",
  promotion: null,
  searchedTrips: [],
  searchMobile: false,
  prevSearchMonths: "",
  prevSearchDestination: "",
  showBroadCategories: defaultBroadCategories,

  // Locale-related state
  language: "en",
  community: "sg",
  currency: "sgd",
  localeLoading: true,

  translations: Object.fromEntries(
    [
      "projects",
      "activities",
      "promotions",
      "highlights",
      "tripReviews",
      "projectItineraryHighlights",
      "projectDailyItineraries",
    ].map((resource) => [resource, {}])
  ),
};

export const { useGlobalState } = createGlobalState(initialState);

// Helper function to update translations
export const updateTranslations = (
  setTranslations,
  resource,
  language,
  data
) => {
  const newTranslationsState = {
    currentLanguage: language,
    resources: {
      ...initialState.translations.resources,
      [resource]: data,
    },
  };

  setTranslations(newTranslationsState);
};
